module.exports = __webpack_public_path__ + "static/img/logo_dark.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/logo_dark.png
// module id = vfDo
// module chunks = 0